import * as gaia from "./gaia";
import * as thor from "./thor";

export const main = [gaia.main, thor.main];
export const stage = main;
